import React, { useContext, useMemo, useState } from 'react';
import "./client-stories-detail.scss";
import { Link, useParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { AppContext } from '../../services/translationContext';

const api = process.env.REACT_APP_URL_API;
const textstring = `
        <div>
            <p><b>Eureka</b>, azienda veneta con una solida storia imprenditoriale, ha scelto <b>Sydea</b> e <b>Indastria Consulting</b> per intraprendere un percorso di modernizzazione dei propri sistemi informativi, migrando con successo a SAP S/4HANA. Un passaggio che rappresenta non solo un’evoluzione tecnologica, ma anche un rafforzamento della visione strategica aziendale: migliorare l’efficienza, rispondere in modo sempre più flessibile alle richieste del mercato e generare valore attraverso l’innovazione. </p>
            <p>Fondata nel 1987, Eureka è specializzata nella progettazione e produzione di componenti in alluminio per il settore dell’arredo, e si è evoluta negli anni fino a diventare partner anche per i settori automotive, domotica, illuminazione, navale e farmaceutico. </p>
            <p>Con 15.000 m² di stabilimenti produttivi in Italia e una presenza consolidata in più di 60 Paesi, Eureka coniuga una visione industriale avanzata con una forte attenzione alla qualità, al design e alla sostenibilità. </p>
            <p>Il cuore dell’azienda è una filiera produttiva interna, verticalizzata e costantemente controllata, che parte dalla lavorazione dei materiali (alluminio, zama, tecnopolimeri) e arriva fino all’assemblaggio e confezionamento, includendo processi innovativi e a basso impatto ambientale, come l’anodizzazione e la verniciatura all’acqua. </p>

            <h2>Un progetto di trasformazione digitale per il futuro </h2>
            <p>La collaborazione tra Eureka, Sydea e Indastria Consulting nasce dalla volontà dell’azienda di <b>affrontare le sfide della digitalizzazione con strumenti all’avanguardia</b>, garantendo al contempo <b>continuità operativa</b> e <b>competitività sul mercato globale</b>. </p>
            <p>Il progetto prevede una <b>migrazione <i>brown-field on-premise</i> del sistema SAP attuale a S/4HANA</b>, e si articola lungo tutto il ciclo di vita dell’implementazione, dalla pianificazione strategica all’esecuzione tecnica. </p>

            <h2>I quattro pilastri del progetto </h2>
            <h3>Migrazione dei dati: un processo strategico </h3>
            <p>Eseguire una migrazione su un sistema ERP attivo da oltre un decennio richiede precisione, competenza e attenzione alla sicurezza. La priorità è <b>garantire un trasferimento dati fluido e affidabile</b>, senza compromettere l’operatività aziendale. </p>
            <h3>Nuove funzionalità e vantaggi di SAP S/4HANA </h3>
            <p>S/4HANA introduce nuove funzionalità che superano i limiti dei sistemi legacy. Per accompagnare questo cambiamento, è stato pianificato un <b>programma di formazione e knowledge transfer</b> rivolto al team interno di Eureka, con l’obiettivo di renderlo autonomo nella gestione del nuovo sistema. </p>
            <h3>Esperienza utente moderna e mobilità </h3>
            <p>Con l’introduzione di interfacce utente evolute, accessibili via web e da dispositivi mobili, Eureka potrà beneficiare di una <b>maggiore flessibilità operativa</b> rispetto al precedente ambiente basato su SAP GUI locale. </p>
            <h3>Integrazione con sistemi terzi </h3>
            <p>L’ERP è parte di un ecosistema digitale complesso. L’<b>integrazione efficace con le piattaforme esterne</b> già in uso da Eureka è fondamentale per garantire continuità e ottimizzare i processi. </p>
            
            <div style='display: flex; margin: 1rem auto;'>
                <img src='https://d3t3s6w5yvhc3g.cloudfront.net/images/client-stories/S:4HANA-Migration-The%204-Key-Pillars.png' style='width: 100%; display: flex'>
            </div>
            
            <h2>Un nuovo traguardo nella nostra missione digitale </h2>
            <p>Per Sydea, ogni progetto è un’opportunità per innovare e contribuire attivamente alla crescita dei propri clienti. La collaborazione con Eureka Italia e Indastria Consulting rappresenta un altro passo importante nel nostro impegno quotidiano verso l’eccellenza nella consulenza SAP e nella trasformazione digitale. </p>
            <p>Siamo orgogliosi di supportare aziende che, come Eureka, uniscono tradizione e innovazione per affrontare il futuro con visione, concretezza e valore. </p>
        </div>
`;

export const ClientStoriesDetail = () => {
  let { story_id, lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  const [storyInfo, setStoryInfo] = useState([]);

  // useMemo(() => {
  //   fetch(`${api}/content-public?url_path=${story_id}`)
  //   .then(response => response.json())
  //   .then(data => {
  //     setStoryInfo(data.data[0]);
  //     document.title = `${TranslationsService.labels(`client_stories`)} - ${data.data[0].title} | ${TranslationsService.getMainInfoCompany('name')}`;
  //   });
  // }, [TranslationsService, story_id]);

  useMemo(() => {
    // fetch(`${api}/content-public?url_path=${story_id}`)
    // .then(response => response.json())
    // .then(data => {
    //   setStoryInfo(data.data[0]);
    //   document.title = `${TranslationsService.labels(`client_stories`)} - ${data.data[0].title} | ${TranslationsService.getMainInfoCompany('name')}`;
    // });
    setTimeout(() => {
      const story = TranslationsService.labels(`client_stories_sect`).filter(x => x.id === story_id)[0];
      setStoryInfo(story);
      document.title = `${TranslationsService.labels(`client_stories`)} - ${story.title} | ${TranslationsService.getMainInfoCompany('name')}`;
    }, 10);
  }, [TranslationsService, story_id]);

  const getHtmlContent = () => {
    try{
      let htmlText = Buffer.from(storyInfo.content, "base64");
      return htmlText;
    }
    catch(e){
      return '';
    }

  }

  return (
    <div className="section-home light">
      <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage: `url(${storyInfo.image_url})`}}>
        <div className='overlay-area-info w-100 d-flex flex-column justify-content-center p-5'>
          <p className='dark-mode-text m-0 breadcrumb-detail'>
            <Link to={`/${lang}`} className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
            &nbsp;&#9656;&nbsp;
            <Link to={`/${lang}/insights`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.insights.label`)}</Link>
            &nbsp;&#9656;&nbsp;
            <Link to={`/${lang}/insights/client-stories`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`client_stories`)}</Link>
          </p>
          <div className='w-75'>
            <h2 className='syd-title light fw-bold sydea-title-xl'>{storyInfo.title}</h2>
            <p className='dark-mode-text fs-3 m-0'>{storyInfo.desc}</p>
          </div>
        </div>
      </section>

      {
        Object.keys(storyInfo).length > 0 &&
        <div className='d-flex flex-wrap p-3'>

          <Link to={`/${lang}/services/${storyInfo.bu_area.key}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
            <p className='m-0'>{TranslationsService.labels(`services.${storyInfo.bu_area.key}.title`)}
            {
              storyInfo.bu_area.sub_items &&
              <span> - {TranslationsService.labels('services')[storyInfo.bu_area.key].items[storyInfo.bu_area.sub_items].title}</span>
            }
            </p>
          </Link>
          
          {
            storyInfo.bu_service.map((service, i) => (
              storyInfo.bu_area.sub_items ?
              (
                <Link key={i} to={`/${lang}/services/${storyInfo.bu_area.key}/${storyInfo.bu_area.sub_items}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                  <p className='m-0 text-end'>{TranslationsService.labels('services')[storyInfo.bu_area.key].items[storyInfo.bu_area.sub_items][service].title}</p>
                </Link>
              )
              :
              (
                <Link key={i} to={`/services/${storyInfo.bu_area.key}/${service}`} className='syd-chips transition-03s-eio text-deco-none syd-black breadcrumb-detail' style={{color:'#141414'}}>
                  <p className='m-0'>{TranslationsService.labels(`services.${storyInfo.bu_area.key}.${storyInfo.bu_service}.title`)}</p>
                </Link>
              )
            ))
          }

        </div>
      }

      {/* <span className='fw-bold dark-mode-title'>{TranslationsService.labels(`services.${_cStory.bu_area.key}.title`)}
                          {
                            _cStory.bu_area.sub_items &&
                            <span> - {TranslationsService.labels('services')[_cStory.bu_area.key].items[_cStory.bu_area.sub_items].title}</span>
                          }
                          </span>
                          <span>
                            {
                              _cStory.bu_service.map((service, i) => (
                                _cStory.bu_area.sub_items ?
                                (
                                  <p className='m-0 text-end'>{TranslationsService.labels('services')[_cStory.bu_area.key].items[_cStory.bu_area.sub_items][service].title}</p>
                                )
                                :
                                (
                                  <p className='m-0'>{TranslationsService.labels(`services.${_cStory.bu_area.key}.${_cStory.bu_service}.title`)}</p>
                                )
                              ))
                            }
                          </span> */}

      <div className='body-text p-3 area-text-cs syd-body-article-p client-story-content'>
        <div dangerouslySetInnerHTML={{ __html: storyInfo.long_text }}></div>
        {/* <div dangerouslySetInnerHTML={{ __html: textstring }}></div> */}
      </div>

    </div>
  );
};
